<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="电台名称">
            <el-input
              v-model="queryForm.name"
              placeholder="请输入电台名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateChange"
              clearable
          >
          </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <!-- <el-button @click="handleQuery" type="primary" icon="el-icon-download">下载excel</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="电台编号"
          prop="card_id"
          height="500"
        />
        <el-table-column
          align="center"
          label="电台名称"
          prop="card_name"
          width="180"
        >
        </el-table-column>
        <el-table-column align="center" prop="finish_time" label="已解锁图片">
          <template slot-scope="{ row }">
            <!-- <img :src="row.front_up" style="width: 70px; height: 70px;" alt="" /> -->
             <el-image 
              style="width: 100px; height: 100px"
              :src="row.front_up"
              v-if="row.front_up"
              :preview-src-list="[row.front_up]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="用户编号"
          prop="user_name"
        >
        </el-table-column>
        <el-table-column align="center" prop="nick_name" label="用户昵称">
        </el-table-column>
        <el-table-column align="center" prop="finish_time" label="解锁日期">
          <template slot-scope="scope">
            {{ transTime(scope.row.translate_time) }}
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="refund_time" label="芯片地址">
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getTranslateUserList } from "@/api/radio"
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryForm: {
        page: 1,
        pageSize: 10,
        name: '',
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      start: '',
      end: '',
    };
  },
  created() {
    this.fetchData();

  },
  mounted() {},

  methods: {
    dateChange(val){
      if(val){
        let [start, end]  = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    async fetchData() {
      let params = {
        start: this.start,
        end: this.end,
        name: this.queryForm.name,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      await getTranslateUserList(params)
      .then((res) => {
        if (res && res.code) {
          this.tableData = res.data.data_list
          this.total = res.data.total_record
        }
      })
      .catch((e) => {
        console.log(e);
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.tableCard {
  margin-top: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}

</style>